import axios from '@/jslib/axios'

export const getDashboard = params => {
  return axios({
    method: 'get',
    url: '/admin/dashboard',
    params
  })
}
export const getNewDashboard = params => {
  return axios({
    method: 'get',
    url: '/admin/statistic/dashboard',
    params
  })
}
